import React, { useEffect, useRef } from "react";
import { Box, useBreakpointValue } from "@chakra-ui/react";
import { DrawingTool, ToolsConfig } from "duck";

interface CustomCursorProps {
  config: ToolsConfig;
  canvasRef: DrawingTool["canvasRef"];
}

const CustomCursor: React.FC<CustomCursorProps> = ({ config, canvasRef }) => {
  const isVisible = useBreakpointValue({ base: false, xl: true });

  const cursorRef = useRef<HTMLDivElement>(null);
  const { mode, penWidth } = config;

  const handleCursorMovement = (event: MouseEvent) => {
    if (cursorRef.current && canvasRef.current) {
      const rect = canvasRef.current.getBoundingClientRect();
      // + 1 due to the extra 2px added to drawing line for smoothing
      const halfOfPointerWidth = penWidth / 2 + 1;

      const x = Math.round(event.clientX - rect.left - halfOfPointerWidth);
      const y = Math.round(event.clientY - rect.top - halfOfPointerWidth);
      cursorRef.current.style.left = `${x}px`;
      cursorRef.current.style.top = `${y}px`;

      const isCursorInsideCanvas =
        x >= -halfOfPointerWidth &&
        x <= rect.width - halfOfPointerWidth &&
        y >= -halfOfPointerWidth &&
        y <= rect.height - halfOfPointerWidth;
      cursorRef.current.style.display = isCursorInsideCanvas ? "block" : "none";
    }
  };

  useEffect(() => {
    document.addEventListener("mousemove", handleCursorMovement);

    return () => {
      document.removeEventListener("mousemove", handleCursorMovement);
    };
  }, [penWidth]);

  return mode === "disabled" || !isVisible ? null : (
    <Box
      style={{ pointerEvents: "none" }}
      display="none"
      position="absolute"
      ref={cursorRef}
      borderRadius="50%"
      h={`${penWidth + 2}px`} // +2px due to the extra 2px added to drawing line for smoothing
      w={`${penWidth + 2}px`}
      bg="blackAlpha.500"
      zIndex={1}
    />
  );
};

export default CustomCursor;
